<script>

    export let icon

</script>

<button type="button" class="button is-white" on:click>
    <span class="icon"><i class="fas fa-{icon}"></i></span>
</button>
